import { render, staticRenderFns } from "./FacilityUnitsList.vue?vue&type=template&id=0d6ab7f2&"
import script from "./FacilityUnitsList.vue?vue&type=script&lang=js&"
export * from "./FacilityUnitsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports